import(/* webpackMode: "eager" */ "/data/jenkins-new/workspace/web-server/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/jenkins-new/workspace/web-server/packages/core/components/provider/QueryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/jenkins-new/workspace/web-server/packages/web-ssr/src/app/[lang]/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppStoreProvider"] */ "/data/jenkins-new/workspace/web-server/packages/web-ssr/src/components/appStore.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/jenkins-new/workspace/web-server/packages/web-ssr/src/components/InitApp/index.tsx");
